import { render, staticRenderFns } from "./NbCourierInformation.vue?vue&type=template&id=007954b0&scoped=true&"
import script from "./NbCourierInformation.vue?vue&type=script&lang=js&"
export * from "./NbCourierInformation.vue?vue&type=script&lang=js&"
import style0 from "./NbCourierInformation.vue?vue&type=style&index=0&id=007954b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007954b0",
  null
  
)

export default component.exports